import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';
import { Button } from '../ui/button';
import { NotificationBell } from '../notifications/NotificationBell';
import { PhoneNavGuard } from './PhoneNavGuard';

export function AppLayout() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <div className="flex h-screen overflow-hidden bg-slate-50" data-testid="app-layout">
            {/* Desktop Sidebar */}
            <aside
                className="w-64 fixed inset-y-0 left-0 z-50 border-r border-slate-200 hidden lg:flex lg:flex-col"
                data-testid="desktop-sidebar"
            >
                <Sidebar />
            </aside>

            {/* Main Content */}
            <div className="flex-1 flex flex-col lg:ml-64 h-screen overflow-y-auto">
                {/* Mobile Header */}
                <header className="lg:hidden flex items-center justify-between p-4 border-b border-slate-200 bg-white sticky top-0 z-40">
                    <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
                        <SheetTrigger asChild>
                            <button
                                type="button"
                                className="inline-flex items-center justify-center w-10 h-10 md:w-14 md:h-14 rounded-md hover:bg-slate-100 text-slate-800"
                                data-testid="mobile-menu-button"
                            >
                                <Menu className="md:hidden" size={24} strokeWidth={2.25} />
                                <Menu className="hidden md:block" size={38} strokeWidth={2.75} />
                            </button>
                        </SheetTrigger>
                        <SheetContent side="left" className="w-64 p-0" data-testid="mobile-sidebar">
                            <Sidebar onClose={() => setMobileMenuOpen(false)} />
                        </SheetContent>
                    </Sheet>
                    <img
                        src="https://customer-assets.emergentagent.com/job_2f371d17-d24a-497f-bf8d-0184002770c6/artifacts/5nav51b9_logo-print-hd.jpg"
                        alt="Logo Big Déménagement"
                        className="h-9 md:h-14 w-auto"
                        data-testid="mobile-header-logo"
                    />
                    <NotificationBell />
                </header>

                {/* Cloche de notifications — flottante en haut à droite (desktop) */}
                <div
                    className="hidden lg:block fixed top-4 right-6 z-40"
                    data-testid="notification-bell-floating"
                >
                    <NotificationBell />
                </div>

                {/* Page Content */}
                <main className="flex-1 min-w-0 overflow-x-hidden" data-testid="main-content">
                    <PhoneNavGuard>
                        <Outlet />
                    </PhoneNavGuard>
                </main>
            </div>
        </div>
    );
}
